import { iFilterItem } from "../types/filterTypes";
import { iEventDetailCMS } from "../types/eventTypes";

enum AplicableKeys {
  FoodTypes = "kindOfFood",
  OccasionType = "occasionType",
  ServiceType = "serviceType",
  City = "city",
}
const aplicableKeys = ["kindOfFood", "occasionType", "serviceType", "city"];
export const makeCmsKeysToValuesAndValuesToKeys = (cms: iEventDetailCMS) => {
  const updatedCMS: iEventDetailCMS = {};
  Object.keys(cms).forEach((key) => {
    updatedCMS[cms[key]] = key;
  });

  return updatedCMS;
};

enum StringFiltersOperators {
  Contains = "contains",
  Equals = "equals",
  IsAnyOf = "isAnyOf",
}

export const getFilteredBussinessIds = (
  cms: iEventDetailCMS,
  filterItems: iFilterItem[]
) => {
  const updatedCmsValues = makeCmsKeysToValuesAndValuesToKeys(cms);
  const cmsKeys = Object.keys(updatedCmsValues);
  const metaData = {
    [AplicableKeys.City]: {} as { [key: string]: string },
    [AplicableKeys.FoodTypes]: {} as { [key: string]: string },
    [AplicableKeys.OccasionType]: {} as { [key: string]: string },
    [AplicableKeys.ServiceType]: {} as { [key: string]: string },
  };
  filterItems.forEach((filter) => {
    if (aplicableKeys.includes(filter.field)) {
      switch (filter.operator) {
        case StringFiltersOperators.Contains:
          cmsKeys.forEach((cmsKey: string) => {
            const valuesArray: string[] = filter.value.split(",");
            valuesArray.forEach((value) => {
              if (cmsKey.toLowerCase().includes(value.toLowerCase())) {
                metaData[filter.field as AplicableKeys][
                  updatedCmsValues[cmsKey]
                ] = cmsKey;
              }
            });
          });
          return;
        case StringFiltersOperators.Equals:
          cmsKeys.forEach((cmsKey: string) => {
            const valuesArray: string[] = filter.value.split(",");
            valuesArray.forEach((value) => {
              if (cmsKey.toLowerCase() === value.toLowerCase()) {
                metaData[filter.field as AplicableKeys][
                  updatedCmsValues[cmsKey]
                ] = cmsKey;
              }
            });
          });
          return;
        case StringFiltersOperators.IsAnyOf:
          cmsKeys.forEach((cmsKey: string) => {
            filter.value.forEach((value: string) => {
              if (cmsKey.toLowerCase() === value.toLowerCase()) {
                metaData[filter.field as AplicableKeys][
                  updatedCmsValues[cmsKey]
                ] = cmsKey;
              }
            });
          });
          return;
      }
    }
  });

  return metaData;
};
